import React from 'react'

const DoxFileIcon = () =>
    <svg width="30" height="34" viewBox="0 0 30 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.6426 0.131348H4.07246C2.06907 0.131348 0.448145 1.63135 0.448145 3.46468L0.429932 30.1313C0.429932 31.9647 2.05085 33.4647 4.05424 33.4647H25.9276C27.931 33.4647 29.5701 31.9647 29.5701 30.1313V10.1313L18.6426 0.131348ZM25.9276 30.1313H4.07246V3.46468H16.8213V11.798H25.9276V30.1313ZM7.71498 21.8147L10.283 24.1647L13.1788 21.5313V28.4647H16.8213V21.5313L19.7171 24.1813L22.2851 21.8147L15.0182 15.1313L7.71498 21.8147Z" fill="#007500" />
    </svg>

export default DoxFileIcon